module.exports = __webpack_public_path__ + "static/media/health_3.8b77d0b1.svg";